export interface RegisterResult {
  status: 'OK' | 'ERROR';
  message: string;
}
